module.exports = __webpack_public_path__ + "img/mir.8ed62d6f.svg";